let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("WYIXX")).then(() => parcelRequire('9K9Yj'));